import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { faArrowTurnDownRight } from "@fortawesome/pro-solid-svg-icons";

import { ChatEmptyStatePrompt } from "src/base-components/Chat/types";
import { Pill } from "src/base-components/Pill";
import { Icon } from "src/design-system/Icon";

type ChatEmptyStateVariant = "legacy" | "new";

type ChatEmptyStateVariantProps = {
  prompts: ChatEmptyStatePrompt[];
  onPromptClick: (prompt: string) => void;
  dataLoc?: string;
};

const ChatEmptyStateLegacySuggestion: React.FC<{
  prompt: string;
  onClick: (prompt: string) => void;
}> = ({ prompt, onClick }) => (
  <button
    className="flex h-32 w-36 appearance-none flex-col items-start gap-y-2 rounded-lg border border-gray-200 bg-gray-50 p-3 text-left font-inter-normal-12px"
    onClick={() => onClick(prompt)}
  >
    <Icon icon={faSearch} size="xs" />
    <p className="text-gray-800">{prompt}</p>
  </button>
);

const ChatEmptyStateLegacy: React.FC<ChatEmptyStateVariantProps> = ({
  prompts,
  onPromptClick,
  dataLoc,
}) => (
  <div
    className="flex h-full flex-grow flex-col items-center justify-center gap-x-2 gap-y-3 p-2"
    data-loc={dataLoc}
  >
    <p className="font-inter-normal-12px text-gray-500">Some ideas...</p>
    <div className="flex items-center gap-x-2">
      {prompts.map((item, index) => (
        <ChatEmptyStateLegacySuggestion
          key={item.prompt + index}
          prompt={item.label}
          onClick={() => onPromptClick(item.prompt)}
        />
      ))}
    </div>
  </div>
);

const ChatEmptyStateNewSuggestion: React.FC<{
  prompt: string;
  onClick: (prompt: string) => void;
}> = ({ prompt, onClick }) => (
  <Pill
    size="lg"
    tabIndex={0}
    variant="indigo-light"
    onClick={() => onClick(prompt)}
  >
    <Pill.Icon icon={faArrowTurnDownRight} size="sm" />
    <Pill.Text>{prompt}</Pill.Text>
  </Pill>
);

const ChatEmptyStateNew: React.FC<ChatEmptyStateVariantProps> = ({
  prompts,
  onPromptClick,
  dataLoc,
}) => (
  <div
    className="flex h-full flex-grow flex-col items-start justify-center gap-y-2.5"
    data-loc={dataLoc}
  >
    <p className="font-inter-normal-12px text-gray-500">Some ideas...</p>
    {prompts.map((item, index) => (
      <ChatEmptyStateNewSuggestion
        key={item.prompt + index}
        prompt={item.label}
        onClick={() => onPromptClick(item.prompt)}
      />
    ))}
  </div>
);

type ChatEmptyStateProps = ChatEmptyStateVariantProps & {
  variant?: ChatEmptyStateVariant;
};

export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({
  variant = "legacy",
  ...props
}) => {
  if (variant === "new") {
    return <ChatEmptyStateNew {...props} />;
  }
  return <ChatEmptyStateLegacy {...props} />;
};
